<template>
  <v-layout fill-height column>
    <v-container flex-fill>
      <div class="question min-height" v-html="ques[0]"></div>
      <draggable v-model="answer" handle=".swipe-drag:not(.disabled)">
        <div v-for="n in replyArr.length" :key="n" class="pos-relative mt-b">
          <Textarea v-model="answer[n-1].textarea"
                    auto-grow
                    rows="1"
                    :placeholder="answer[n-1].reply"
                    :readonly="cmplt"
                    class="textarea"
          />
          <v-btn plain :ripple="false" class="swipe-drag" :class="{ 'disabled' : cmplt }"></v-btn>
        </div>
      </draggable>
    </v-container>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import store from '@/store'
import draggable from 'vuedraggable'
import Textarea from "@/components/forms/Textarea"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    disabledNext: true,
    free: 'N',
    cmplt: false,
    answer: [],
    ques: [],
    replyArr: [],
    replyObjArr: [],
    userReplyNo: [],
    userReply: [],
  }),
  components: {
    Textarea,
    draggable,
    FooterBtnsNext,
  },
  watch: {
    answer: {
      handler: function () {
        for (let len = 0; len < this.answer.length; len++) {
          if (this.answer[len].textarea != undefined && this.answer[len].textarea.trim() != '' && this.answer[len].textarea.length <= 200) {
            this.disabledNext = false
          } else {
            this.disabledNext = true
            break
          }
        }
      },
      deep: true,
      immediate: true,
    },
    current() {
      // alert(this.current)
      // 동일 타입 재 조회시 초기화
      this.answer = [],
          this.disabledNext = true,
          this.free = 'N',
          this.cmplt = false,
          this.ques = [],
          this.replyArr = [],
          this.replyObjArr = [],
          this.userReplyNo = [],
          this.userReply = [],
          this.getUnitDetailUse()
    }
  },
  created() {
    this.getUnitDetailUse()
  },
  methods: {
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = (this.cmpltYn === 'true' || this.cmpltYn === true) ? true : false
      // this.cmplt = true

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
          .then(res => {
            if (res.success) {

              // 질문 리스트
              res.data.unitDtlQuesList.forEach((quesEl, i) => {

                // 질문 셋팅
                // this.ques[i] = quesEl.ques
                this.ques.push(quesEl.ques)

                // 답변 셋팅
                quesEl.unitDtlReplyList.forEach((replyEl) => {
                  // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                  this.replyArr.push(replyEl.reply)
                  this.replyObjArr.push(replyEl)
                  this.answer.push(replyEl)
                  this.userReplyNo.push(0)
                });
                // 유저 답변 셋팅
                if (quesEl.memberUnitDtlReplyList.length > 0) {
                  // 답변 비우고
                  this.answer.splice(0, this.answer.length);

                  quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                    this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo
                    userReplyEl.textarea = userReplyEl.reply
                    userReplyEl.reply = this.replyArr[j]
                    this.answer.push(userReplyEl)
                  });
                }
              });

            } else {
              console.log(res.msg)
              // this.answer = [];
            }
          })
          .catch(error => {
            console.error(error)
            // this.answer = [];
          })
          .finally(() => {
          })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 우선순위 답변
        this.answer.forEach((replyObj, i) => {
          this.userReply[i] = {
            unitId: replyObj.unitId,
            sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

            memberUnitDtlReplyUseNo: this.userReplyNo[i],
            // unitUseNo: replyObj.unitUseNo,
            unitNo: replyObj.unitNo,
            // unitDtlUseNo: replyObj.unitDtlUseNo,
            unitDtlNo: replyObj.unitDtlNo,
            // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
            unitDtlQuesNo: replyObj.unitDtlQuesNo,
            // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
            unitDtlReplyNo: replyObj.unitDtlReplyNo,
            userKey: this.$store.state.auth.authUser.userKey,
            reply: replyObj.textarea,
            score: i + 1,
            freeYn: this.free,
            // unitType:"09",
            // dtlType:"11"
          }
        })

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
            .then(res => {
              if (res.success) {
                setTimeout(() => this.$emit('next'), 500); // 저장한 이후
              } else {
                console.log(res.msg)
              }
            })
            .catch(error => {
              console.error(error)
            })
            .finally(() => {
            })
      } else {
        this.$emit('next')
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep.textarea {
  .v-input__slot {
    background-color: #fff !important;

    textarea {
      padding-right: 50px !important;
      padding-left: 8px !important;

      &:not([readonly="readonly"]) {
        max-height: 150px !important;
        overflow-y: auto !important;
      }

      &[readonly="readonly"] {
        margin-bottom: 8px;
      }
    }
  }

  box-shadow: 0px 2px 6px #00000029;
  border-radius: 6px;
}
</style>
